import { addUserToColorMap } from 'gcs-common/slices/channels/channelsSlice';
import {
  getAuthorNameColor,
  getMessageAuthorId,
  getMessageAuthorName,
} from 'gcs-common/slices/messages/messageSelector';
import { getUserLoaded } from 'gcs-common/slices/user/userSelectors';
import { fetchUser } from 'gcs-common/slices/users/usersThunks/fetchUser';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';

const MessageName = ({ channelId, messageId }) => {
  const authorName = useSelector(getMessageAuthorName(messageId, channelId));
  const authorId = useSelector(getMessageAuthorId(messageId));
  const isAuthorLoaded = useSelector(getUserLoaded(authorId));
  const usernameColor = useSelector(getAuthorNameColor(channelId, authorId));
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthorLoaded && authorId) {
      dispatch(fetchUser({ id: authorId }));
    }
  }, [authorId, dispatch, isAuthorLoaded, messageId]);

  useEffect(() => {
    if (!usernameColor) {
      // it is necessary to do this computation on demand
      // and not per selector since at any time messages from previously
      // unknown authors can be added at the beginning (load prev messages)
      // or the end (receive new message) of the channelMessages
      dispatch(addUserToColorMap({ channelId, id: authorId }));
    }
  }, [authorId, channelId, dispatch, usernameColor]);
  // do not show ugly flashing of default color if color is not yet defined but rather hide name
  const visibility = usernameColor ? 'visible' : 'hidden';
  return (
    <div style={{ color: usernameColor, visibility }} className={styles.nameHeader}>
      {authorName}
    </div>
  );
};

MessageName.propTypes = {
  channelId: PropTypes.string.isRequired,
  messageId: PropTypes.string.isRequired,
};

export default MessageName;
